<template>
    <Input class="m-auto" @changed="validate"/>
</template>

<script>
import Input from './CodeInput'

export default {
  name: 'Validator',
  emits: ['validate'],
  components: {
    Input
  },
  methods: {
    validate (value) {
      this.$emit('validate', value)
    }
  }
}
</script>
